import { useCallback, useMemo, useState } from "@wordpress/element";

export function useGeolocation(options) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const onSuccess = useCallback(function (data) {
    setData(data);
    setSuccess(true);
    setLoading(false);
  }, []);

  const onError = useCallback(function (error) {
    setError(error);
    setSuccess(false);
    setLoading(false);
  }, []);

  return [
    useMemo(
      function () {
        return { data, loading, success, error };
      },
      [data, loading, success, error]
    ),
    useCallback(
      function () {
        if (!navigator || !navigator.geolocation) return;
        setLoading(true);
        navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
      },
      [options, onSuccess, onError]
    ),
    !!navigator &&
      !!navigator.geolocation &&
      !!navigator.geolocation.getCurrentPosition,
  ];
}

// const options = {
//   enableHighAccuracy: true,
//   timeout: 5000,
//   maximumAge: 0,
// };

// function success(pos) {
//   const crd = pos.coords;

//   console.log("Your current position is:");
//   console.log(`Latitude : ${crd.latitude}`);
//   console.log(`Longitude: ${crd.longitude}`);
//   console.log(`More or less ${crd.accuracy} meters.`);
// }

// function error(err) {
//   console.warn(`ERROR(${err.code}): ${err.message}`);
// }

// ;
